export default function isTemplateTypologyAccessible(typology) {
  return [
    'countdown',
    'editorial-content',
    'end-event',
    'video',
    'equirectangular-video',
    'equirectangular-picture',
    'flat-picture',
    'live-story',
    'thron-player',
    'iframe',
    'social-widget',
    'product-education',
    'slideshow',
    'pdf-viewer',
    '3d-viewer',
    'sketchfab-gallery',
    'sketchfab-3d-viewer'
  ].indexOf(typology) !== -1;
}
